import { FC, PropsWithChildren, Suspense, lazy } from "react";

import { blockchain } from "../../../settings";

// import Spinner from "../../UI/Spinner/Spinner";


// const TonConfig = lazy(() => import('./configs/TonConfig'));
const BscConfig = lazy(() => import('./configs/BscConfig'));
// const WfConfig = lazy(() => import('./configs/WfConfig'));


const IndexWrapper: FC<PropsWithChildren> = ({children}) => {

	switch (blockchain) {
		// case 'waterfall':
		// 	return (
		// 		<Suspense
		// 			fallback={<Spinner/>}
		// 		>
		// 			<WfConfig>
		// 				{children}
		// 			</WfConfig>
		// 		</Suspense>
		// 	)
		// ;
		case 'binance':
		case 'chromia':
			return (
				// <Suspense
				// 	fallback={<Spinner/>}
				// >
					<BscConfig>
						{children}
					</BscConfig>
				// </Suspense>
			)
		;

		// case 'ton':
		// 	return (
		// 		<Suspense
		// 			fallback={<Spinner/>}
		// 		>
		// 			<TonConfig>
		// 				{children}
		// 			</TonConfig>
		// 		</Suspense>
		// 	)
		// ;

		default: throw new Error();
	}
}

export default IndexWrapper;